// extracted by mini-css-extract-plugin
export default {"container":"M2Tips_container__3Btae","triangle":"M2Tips_triangle__d9g-N","containerSOM":"M2Tips_containerSOM__wkjAN"};